module.exports = __webpack_public_path__ + "img/rick_morty_api_response.6b90baab.png";